import { useState } from "react";
import type { FormEvent } from "react";
import { KeyRound, LoaderCircle, LockKeyhole, Wine } from "lucide-react";
import { api } from "../api/client";

export function LoginPage({ onSuccess, configurationError }: { onSuccess: () => void; configurationError?: string }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState(configurationError ?? "");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (!password) return;
    setSubmitting(true);
    setError("");
    try {
      await api.login(password);
      setPassword("");
      onSuccess();
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "ログインできませんでした");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-card" aria-labelledby="login-title">
        <div className="login-brand">
          <span className="login-brand__mark"><Wine size={27} aria-hidden="true" /></span>
          <div><strong>D&amp;C Sales</strong><span>Bar operation ledger</span></div>
        </div>
        <div className="login-intro">
          <span className="login-intro__icon"><LockKeyhole size={22} aria-hidden="true" /></span>
          <h1 id="login-title">売上管理へログイン</h1>
          <p>共有されたパスワードを入力してください。ログイン状態は12時間保持されます。</p>
        </div>
        <form className="login-form" onSubmit={submit}>
          <label className="field">
            <span className="field__label">共有パスワード</span>
            <span className="password-input">
              <KeyRound size={17} aria-hidden="true" />
              <input
                type="password"
                value={password}
                autoComplete="current-password"
                placeholder="パスワードを入力"
                onChange={(event) => setPassword(event.target.value)}
              />
            </span>
          </label>
          {error ? <div className="login-error" role="alert">{error}</div> : null}
          <button type="submit" className="button button--primary login-submit" disabled={!password || submitting}>
            {submitting ? <LoaderCircle className="spin" size={18} /> : <LockKeyhole size={18} />}
            {submitting ? "確認しています…" : "ログイン"}
          </button>
        </form>
        <p className="login-note">パスワードはこの画面からGoogleスプレッドシートへ送信されません。</p>
      </section>
    </main>
  );
}
